import { useParams } from "react-router-dom";
import QuizQandA from "./components/QuizQandA";
import Header from "../components/Header";

function QuestionsAndAnswersPage() {
    const { courseId, lectureId, itemId } = useParams();
    let pagesLinks = [
        {
            name: "الأسالة بالأجابات",
            link: `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/view`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },
        {
            name: "محتويات المحاضره",
            link: `/admin/courses/${courseId}/lectures/${lectureId}`,
        },
        {
            name: "اسألة الأختبار",
            link: `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}`,
        },
    ];
    return (
        <>
            <Header
                pageName="الأسالة بالأجابات"
                pages={pagesLinks}
                className="text-2xl"
            />
            <QuizQandA />
        </>
    );
}

export default QuestionsAndAnswersPage;
